import * as React from 'react';
import { MediaGalleryContext } from './hooks/use-media-gallery-context';
import { useMediaGalleryReducer } from './hooks/use-media-gallery-reducer';
export const MediaGalleryContextProvider = ({ children }) => {
    const [state, dispatch, getState] = useMediaGalleryReducer();
    const value = React.useMemo(() => ({ state, dispatch, getState }), [state, dispatch, getState]);
    return (React.createElement(MediaGalleryContext.Provider, { value: value }, children));
};
